import checkAndSendEmail from '../actions/checkAndSendEmail.js'
import setRecoverySnackbarError from '../actions/setRecoverySnackbarError.js'
import setRecoverySnackbarSuccess
  from '../actions/setRecoverySnackbarSuccess.js'

export default [
  checkAndSendEmail,
  {
    success: [setRecoverySnackbarSuccess],
    error: [setRecoverySnackbarError]
  }
]



// WEBPACK FOOTER //
// ./src/modules/login/chains/onForgotPassword.js